module.exports = __webpack_public_path__ + "img/09.a5500da7.jpg";